export default "__VITE_ASSET__5d1377b5__"